function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Banner, Center, EmptyState, Spinner } from "@neru/ui";
import { classNames } from "@neru/utils";
export var DelayedWrapper = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ _jsx(Center, {
        className: classNames(className, "opacity-0 animate-fadeIn"),
        children: children
    });
};
export var State = function(_param) {
    var children = _param.children, _param_emptyStateIcon = _param.emptyStateIcon, emptyStateIcon = _param_emptyStateIcon === void 0 ? "file-search-line" : _param_emptyStateIcon, _param_emptyStateMessage = _param.emptyStateMessage, emptyStateMessage = _param_emptyStateMessage === void 0 ? "No records found" : _param_emptyStateMessage, errorIcon = _param.errorIcon, errorMessage = _param.errorMessage, isData = _param.isData, loading = _param.loading, withLoadMore = _param.withLoadMore, rest = _object_without_properties(_param, [
        "children",
        "emptyStateIcon",
        "emptyStateMessage",
        "errorIcon",
        "errorMessage",
        "isData",
        "loading",
        "withLoadMore"
    ]);
    if (loading && !withLoadMore) {
        return /*#__PURE__*/ _jsx(Spinner, {});
    }
    if (errorMessage) {
        if (errorIcon) {
            var _rest_datatestid;
            return /*#__PURE__*/ _jsx(DelayedWrapper, {
                children: /*#__PURE__*/ _jsx(EmptyState, {
                    body: errorMessage,
                    "data-testid": (_rest_datatestid = rest["data-testid"]) !== null && _rest_datatestid !== void 0 ? _rest_datatestid : "error-state",
                    heading: "Something went wrong",
                    icon: errorIcon
                })
            });
        }
        return /*#__PURE__*/ _jsx(DelayedWrapper, {
            className: "py-8",
            children: /*#__PURE__*/ _jsx(Banner, {
                connotation: "alert",
                "data-testid": "alert-banner",
                message: errorMessage,
                open: true
            })
        });
    }
    if (!isData && !loading) {
        var _rest_datatestid1;
        return /*#__PURE__*/ _jsx(DelayedWrapper, {
            children: /*#__PURE__*/ _jsx(EmptyState, {
                "data-testid": (_rest_datatestid1 = rest["data-testid"]) !== null && _rest_datatestid1 !== void 0 ? _rest_datatestid1 : "empty-state",
                heading: emptyStateMessage,
                icon: emptyStateIcon
            })
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            withLoadMore && loading && /*#__PURE__*/ _jsx(Center, {
                className: "py-20",
                children: /*#__PURE__*/ _jsx(Spinner, {})
            })
        ]
    });
};

//# sourceMappingURL=State.js.map